import { render } from "./Validate.vue?vue&type=template&id=653cba30&scoped=true"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"

import "./Validate.vue?vue&type=style&index=0&id=653cba30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653cba30"]])

export default __exports__